import { envConfigs } from '../envConfigs';
import {
  isCatalyst,
  getProductInfoByProductId,
  gaiaKey,
  adminToolsKey,
  luisenoKey
} from './productConfigHelper';

const LOCALHOST = 'localhost';

// mapLocalLinks() is for development use - replaces the recommendation links
//  from LPS with the links which are installed by grunt, which are
//  maybe localhost URIs
export const mapLocalLinks = (recommendations) => {
  function getUriFromProductId(productId) {
    const productInfo = getProductInfoByProductId(productId);
    if (productInfo) {
      switch (productInfo.key) {
        case gaiaKey:
          return envConfigs.gaiaUri;
        case adminToolsKey:
          return envConfigs.rsmUri;
        case luisenoKey:
          return envConfigs.gaiaUri;
        default:
          return null;
      }
    }
    return null;
  }

  // if all the configured URIs contain localhost then remap the recommendations link
  if (
    envConfigs.rsmUri &&
    envConfigs.rsmUri.indexOf(LOCALHOST) > -1
  ) {
    recommendations.map((entry) => {
      if (entry && entry.category !== 'LTS' && entry.category !== 'questionnaire' && entry.product_id) {
        let newUri;
        if (isCatalyst(entry.product_id) && entry.sub_product_id) {
          newUri = getUriFromProductId(entry.sub_product_id);
        } else {
          newUri = getUriFromProductId(entry.product_id);
        }
        if (newUri) {
          entry.recommendation = newUri;
        }
      }
      return entry;
    });
  }
  return recommendations;
};



// WEBPACK FOOTER //
// ./src/helpers/localDevHelper.js